import React,{useEffect,useContext,useState,useCallback} from 'react'
import {Grid} from "@mui/material";
import { CONSTANTS } from '../../../common/utility/constant';
import DashboardHeader from '../../../components/AppHeader/header';
import { useNavigate } from 'react-router-dom';
import { useAxiosWithAuth } from '../../../common/api/hooks/useAxiosWithAuth';
import { URL } from '../../../common/api/urls';
import {UserSettingsContext} from '../../../setup/routes-manager/RequireAuth';
import useAuth from '../../../common/hooks/useAuth';
import usePermissions from '../../../common/hooks/usePermissions';
import NotificationPopup from './notification_popup';
import SubscriberAgreementPopup from './subscriber_agreement_popup';
import MobileOtpVerificationDialog from '../../login-register/register/MobileOtpVerificationDialog';
import ToolsWalkthroughPopup from './tools_walkthrough_pop_up';
import FreeToolsModal from './free_tools';
import FreeToolSteelCardHost from './free_tool_steel_card_host';
import FreeUserDelayStrip from './free_user_delay_strip';
import WelcomeModal from './welcome_login_modal';
import UserManualMarketingPopup from './user_manual_marketing_popup';
import OpeningWalkthroughCoach from './open_walkthrough_coach';
import { MANUAL_SECTIONS } from '../../../common/utility/constant';
import PopupRenderer from '../../PopupRenderer';

/**
 * 
 * @param {*} param0 
 * @returns Main container for the dashboard
 */
function DashboardLayoutContainer({children}) {
    const navigate = useNavigate();
    const [cancelAccept, acceptResponse, acceptError, acceptLoaded, resetAccept, executeAcceptAPI] = useAxiosWithAuth();
    const [isAcceptingTos, setIsAcceptingTos] = useState(false);
    const { auth, setAuth } = useAuth();
    const permissions = usePermissions();
    const contentTopOffset = CONSTANTS.DASHBOARD_HEADER_HEIGHT;
    const [cancelInfoAck,infoAckResponse,infoAckError,infoAckLoaded,resetInfoAck,executeInfoAckAPI] = useAxiosWithAuth();
    const {
        userSettings,setUserSettings,
        headerData,setHeaderData,
        notifData,setNotifData,
        showNotif,setShowNotif,
        showWelcomeModal,setShowWelcomeModal,
        showFreeToolsModal,setShowFreeToolsModal,
        showToolsWalkthrough,
        showOFWalkthroughCoach,
        setShowOFWalkthroughCoach,
        toolsWalkthroughInitialId,
        openToolsWalkthrough,
        closeToolsWalkthrough,
        showUserManualMarketingPopup,setShowUserManualMarketingPopup,
        showInfoPopup,setShowInfoPopup,
        infoPopupData,setInfoPopupData,
        setShowMPChartWalkthrough,
        setShowMPSection,
    } = useContext(UserSettingsContext);

    console.log("infoDataPopup: ", infoPopupData);
    const showContactVerify = Boolean(auth?.contact_verify_notify && !auth?.tos_notify);
    const showPromoNotif = Boolean(showNotif && notifData && !auth?.tos_notify && !showContactVerify);
    const allowContactVerifySkip = !permissions.isFreeUser();
        useEffect(()=>{
       setHeaderData(undefined);
    },[])
    
    const setRoute=(route,component)=>{
        console.log("HeaderData Mainlayout=setRoute",headerData)
     setHeaderData(undefined);
      console.log("Route at main_layout=",route);
      navigate(route, {stateNew: { id: 7, color: 'green',userSetting:userSettings }, replace: true });
    //   setCurrentComponent(component);
    }

    const handleCloseNotificationPopup = () => {
        setShowNotif(false);
    }
     const handleStartExploring = () => {
         setShowWelcomeModal(false);
         openToolsWalkthrough("overview");
     };

    const handleOpenUserManual = () => {
        const mpIndex = MANUAL_SECTIONS?.findIndex(
            (section) =>
                section.title?.toLowerCase().trim() === "explore marketprofile",
        );

        if (setShowMPSection) {
            setShowMPSection(
                mpIndex !== -1 && mpIndex !== undefined ? mpIndex : 4,
            );
        }

        if (setShowMPChartWalkthrough) {
            setShowMPChartWalkthrough(true);
        }
    };

    const handleCloseToolsWalkthrough = () => {
        closeToolsWalkthrough();
    };
    const handleSubscriberAgreementAccept = () => {
        if (isAcceptingTos) return;
        setIsAcceptingTos(true);
        executeAcceptAPI(URL.ACCEPT_TOS, "POST", {});
    }

    useEffect(() => {
        if (!acceptLoaded) return;
        if (!acceptError && acceptResponse != null) {
            setAuth((prev) => ({ ...prev, tos_notify: false }));
        }
        setIsAcceptingTos(false);
        resetAccept();
    }, [acceptLoaded, acceptResponse, acceptError, resetAccept, setAuth]);

    const handleContactVerifySuccess = useCallback(() => {
        setAuth((prev) => ({ ...prev, contact_verify_notify: false }));
    }, [setAuth]);

    const handleContactVerifySkip = useCallback(() => {
        setAuth((prev) => ({ ...prev, contact_verify_notify: false }));
    }, [setAuth]);

    const handleCloseInfoPopup = useCallback(() => {
        const infoMessageId =infoPopupData?.id 

        if (infoMessageId != null) {
            executeInfoAckAPI(URL.INFO_MESSAGE_ACK, "POST", {
                id: infoMessageId,
            });
        } else if (process.env.NODE_ENV !== "production") {
            console.warn(
                "Info popup closed without an ackable id:",
                infoPopupData,
            );
        }

        setShowInfoPopup(false);
        setInfoPopupData(null);
    }, [infoPopupData, executeInfoAckAPI, setShowInfoPopup, setInfoPopupData]);


    return (
        <>
            <DashboardHeader
                setCurrentRoute={setRoute}
                headerData={headerData}
                openToolsWalkthrough={() => openToolsWalkthrough("overview")}
            />
            <div
                style={{
                    paddingTop: `${contentTopOffset}px`,
                    position: "relative",
                    minHeight: `calc(100vh - ${contentTopOffset}px)`,
                    display: "flex",
                    flexDirection: "column",
                }}
            >
                <FreeUserDelayStrip />
                <Grid
                    container
                    component="main"
                    sx={{
                        flex: 1,
                        minHeight: 0,
                    }}
                >
                    {children}
                </Grid>
            </div>

            {/* Notification Popup — deferred while TOS/contact take priority */}
            {showPromoNotif && (
                <NotificationPopup
                    open={showPromoNotif}
                    onClose={handleCloseNotificationPopup}
                    notifData={notifData}
                />
            )}
            <PopupRenderer
                open={showInfoPopup}
                onClose={handleCloseInfoPopup}
                popupData={infoPopupData}
            />
            {auth?.tos_notify && (
                <SubscriberAgreementPopup
                    open={!!auth.tos_notify}
                    onAccept={handleSubscriberAgreementAccept}
                    accepting={isAcceptingTos}
                />
            )}

            {showContactVerify && auth?.email_id && (
                <MobileOtpVerificationDialog
                    open={showContactVerify}
                    email={auth.email_id}
                    allowEditContact
                    dismissible={false}
                    onVerifySuccess={handleContactVerifySuccess}
                    onSkip={
                        allowContactVerifySkip
                            ? handleContactVerifySkip
                            : undefined
                    }
                />
            )}
            <ToolsWalkthroughPopup
                open={showToolsWalkthrough}
                onClose={handleCloseToolsWalkthrough}
                initialActiveId={toolsWalkthroughInitialId}
            />
            <FreeToolsModal
                open={showFreeToolsModal}
                onClose={() => setShowFreeToolsModal(false)}
            />
            <WelcomeModal
                open={showWelcomeModal}
                onClose={() => setShowWelcomeModal(false)}
                onStartExploring={handleStartExploring}
            />
            <UserManualMarketingPopup
                open={showUserManualMarketingPopup}
                onClose={() => setShowUserManualMarketingPopup(false)}
                onOpenManual={handleOpenUserManual}
            />
            <OpeningWalkthroughCoach
                open={showOFWalkthroughCoach}
                onClose={() => setShowOFWalkthroughCoach(false)}
            />
            <FreeToolSteelCardHost />
        </>
    );
}

export default DashboardLayoutContainer
